const o = (e) => !e, t = (e) => !!e;
export {
  t as cleanArrayPredicate,
  o as togglePredicate
};
//# sourceMappingURL=predicate.js.map
